import axios from 'axios'
import cookie from 'react-cookies'
import axiosRetry from 'axios-retry'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import ApiURL from './ApiUrl'

axiosRetry(axios, { retries: 5 })

export const createMeeting = async () => {
  let result
  const createMeetingConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/create_meeting/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    'axios-retry': {
      retries: 5,
    },
  }

  await axios(createMeetingConfig)
    .then((response) => {
      result = response.data
    })
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })

  return result
}

export const createAttendee = async (meetingId) => {
  let result
  const createAttendeeConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/create_attendee/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    'axios-retry': {
      retries: 5,
    },
    data: {
      meeting_id: meetingId,
    },
  }

  await axios(createAttendeeConfig)
    .then((response) => {
      result = response.data

      // console.log(response)
    })
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })

  return result
}

export const createMeetingWithAttendies = async (roomId) => {
  let result
  const createMeetingWithAttendiesConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/create_meeting_with_attendies/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    'axios-retry': {
      retries: 5,
    },
    data: {
      room_id: roomId,
    },
  }

  await axios(createMeetingWithAttendiesConfig)
    .then((response) => {
      result = response.data
    })
    .catch(async (error, response) => {})

  return result
}

export const getMeetingWithAttendies = async () => {
  let result

  await axios
    .get(`${ApiURL}/api/aws_chime/chime_controller/meeting_detail/`, {
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'),
      },
      'axios-retry': {
        retries: 5,
      },
    })
    .then((response) => {
      if (response.data) {
        result = response.data
      }
    })

    .catch((error) => {
      console.log(error)
    })

  return result
}

export const userJoinToMeeting = async (roomId) => {
  let result = false
  const getJoinToMeeting = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/join_to_meeting/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    'axios-retry': {
      retries: 5,
    },
    data: {
      room_id: roomId,
    },
  }

  await axios(getJoinToMeeting)
    .then((response) => {
      result = true
    })
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })

  return result
}

export const voteToKickUser = async (userId, meetingId, firebaseIndexKey) => {
  let result

  const getJoinToMeeting = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/vote_kick/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      target: userId,
      meeting: meetingId,
      user_id: firebaseIndexKey,
    },
  }

  await axios(getJoinToMeeting)
    .then((response) => {
      result = response.data
    })
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })

  return result
}

export const voteToMuteUser = async (
  userId,
  meetingId,
  muteAttendeeFirebaseIndex
) => {
  let result

  const getJoinToMeeting = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/vote_mute/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    'axios-retry': {
      retries: 5,
    },
    data: {
      target: userId,
      meeting: meetingId,
      user_id: muteAttendeeFirebaseIndex,
    },
  }

  await axios(getJoinToMeeting)
    .then((response) => {
      result = response.data
    })
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })

  return result
}

export const voteKickDeleteUser = async (
  userId,
  meetingId,
  firebaseIndexKey
) => {
  //   POST /api/aws_chime/chime_controller/vote_kick_delete_attendee/
  // {
  // 	"target": 1,
  // 	"meeting": 1,
  //     "user_id": "-MflA3kI79tDewWq7HNp"
  // }

  const voteKickDeleteUserConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/vote_kick_delete_attendee/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    'axios-retry': {
      retries: 5,
    },
    data: {
      target: userId,
      meeting: meetingId,
      user_id: firebaseIndexKey,
    },
  }

  await axios(voteKickDeleteUserConfig)
    .then((response) => {})
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })
}

export const chimeRemoveUserFromQueue = async (roomId, userId) => {
  const removeUserFromQueueConfig = {
    method: 'delete',
    url: `${ApiURL}/api/aws_chime/chime_controller/remove_user_from_queue/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      room_id: roomId,
      user_id: userId,
    },
  }

  await axios(removeUserFromQueueConfig)
    .then((response) => {})
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })
}

export const addUserToQueue = async (roomId, userId) => {
  const addUserToQueueConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/add_user_to_queue/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      room_id: roomId,
      user_id: userId,
    },
  }

  await axios(addUserToQueueConfig)
    .then((response) => {})
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })
}

export const chimeSelfMuteUser = async (roomId, userId, isUserSelfMuted) => {
  const chimeSelfMuteUserConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/self_mute/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      room_id: roomId,
      user_id: userId,
      is_user_self_muted: isUserSelfMuted,
    },
  }

  await axios(chimeSelfMuteUserConfig)
    .then((response) => {})
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })
}

export const chimeCameraOffUser = async (roomId, userId, isUserCameraOff) => {
  const chimeCameraOffUserConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/chime_controller/self_camera_off/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      room_id: roomId,
      user_id: userId,
      is_user_camera_off: isUserCameraOff,
    },
  }

  await axios(chimeCameraOffUserConfig)
    .then((response) => {})
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })
}

export const chimeReportConferenceBug = async (bugMessage) => {
  const chimeReportConferenceBugConfig = {
    method: 'post',
    url: `${ApiURL}/api/aws_chime/conference_bugs/report_conference_bug/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      text: bugMessage,
    },
  }

  await axios(chimeReportConferenceBugConfig)
    .then((response) => {
      // console.log(response)
    })
    .catch(async (error) => {
      console.log(error.response)

      if (error.response.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error.response)
      }
    })
}
